export default langsData => [
  {
    path: '/tokusyouhou',
    name: 'tokusyouhouPC',
    component: ()=> import(/* webpackChunkName: "tokusyouhou" */ "@/views/tokusyouhou/pc/index.vue"),
    meta: {
      title: langsData['tokusyouhou'].title,
    }
  },
  {
      path: '/tokusyouhou/h5',
      name: 'tokusyouhouH5',
      component: ()=> import(/* webpackChunkName: "tokusyouhouH5" */ "@/views/tokusyouhou/h5/index.vue"),
      meta: {
        title: langsData['tokusyouhou'].title,
      },
      baseWidth: "360"
  }
]
